import * as React from 'react';
import { useEffect, useState } from 'react';
import Box from './Box';
import './GameBoard.css';
import Pawn from './Pawn';

const GameBoard = ({ game }) => {
    const [, setBoxes] = useState([...game.boxes]);
    const [, setMoves] = useState([...game.moves]);
    const [, setPawnPosition] = useState([...game.pawnPosition]);
    const [, setSelectedPawn] = useState(game.selectedPawn);
    const [, setPlayerTurn] = useState(game.playerTurn);
    useEffect(() => game.observeBoxes(setBoxes), [game]);
    useEffect(() => game.observeMoves(setMoves), [game]);
    useEffect(() => game.observePawnPosition(setPawnPosition), [game]);
    useEffect(() => game.observeSelectedPawn(setSelectedPawn), [game]);
    useEffect(() => game.observePlayerTurn(setPlayerTurn), [game]);

    return (
        <div className='game-state'>
            <div className='player-turn'>{game.winner === null ? `${game.playerName[game.playerTurn]}'s turn` : `${game.playerName[game.winner]} win!`}</div>
            <div className='game-board'>
            {game.boxes.map((boxId: number) => 
                <div key={`box-${boxId}`} className='box-container'>
                    <div>{boxId + 1}</div>
                    <Box key={`box-${boxId}`} boxId={boxId} game={game} />
                    <div className='pawn-container'>
                        {game.pawnContainer[boxId].length > 0 ? game.pawnContainer[boxId].slice(1).map((pawnId: number) => 
                        <Pawn key={`pawn-${pawnId}`} pawnId={pawnId} game={game} />) : null}
                    </div>
                </div>
            )}</div>
        </div>
    );
}

export default GameBoard;